import React, { useState, useEffect } from "react";
import axios from "axios";
import { AuthGuard } from "../App";
import { EmailGuard } from "../App";
import { toast } from "react-toastify";
import { Oval } from "react-loader-spinner"; // Import loader
import { StandardURL } from "../App";

const WithdrawalRateChargePage = () => {
  const [withdrawalCharges, setWithdrawalCharges] = useState([]);
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState("");
  const [modalData, setModalData] = useState({
    property_id: "",
    withdrawalfee: "",
  });

  const [isLoading, setIsLoading] = useState(false); // Add loading state

  useEffect(() => {
    fetchWithdrawalFee();
  }, []);

  const fetchWithdrawalFee = () => {
    const token = localStorage.getItem("token");
    axios
      .get(
        `${StandardURL}/iNyumba/withdrawalfeecharge/fetchall`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setWithdrawalCharges(response.data.response);
      })
      .catch((error) => {
        console.error("Error fetching service charges:", error);
        toast.error(error.response.data.response);
      });
  };

  const handleUpdateWithdrawalCharge = () => {
    setIsLoading(true); // Set loading state to true
    const token = localStorage.getItem("token");
    const { withdrawalfee } = modalData;
    axios
      .patch(
        `${StandardURL}/iNyumba/withdrawalfeecharge/update/${selectedPropertyId}`,
        { withdrawalfee },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsModalOpen(false);
        fetchWithdrawalFee();
        toast.success(response.data.response);
        setIsLoading(false); // Set loading state to false
      })
      .catch((error) => {
        console.error("Error updating service charge:", error);
        toast.error(error.response.data.response);
        setIsLoading(false); // Set loading state to false
      });
  };

  const handleDeleteWithdrawal = (propertyId) => {
    const token = localStorage.getItem("token");
    axios
      .delete(
        `${StandardURL}/iNyumba/withdrawalfeecharge/delete/${propertyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        fetchWithdrawalFee();
        toast.success(response.data.response);
      })
      .catch((error) => {
        console.error("Error deleting service charge:", error);
        toast.error(error.response.data.response);
      });
  };

  const handleAddWithdrawalFee = () => {
    const token = localStorage.getItem("token");
    const { property_id, withdrawalfee } = modalData;
    axios
      .post(
        `${StandardURL}/iNyumba/withdrawalfeecharge/add`,
        { property_id, withdrawalfee },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setIsModalOpen(false);
        fetchWithdrawalFee();
        toast.success(response.data.response);
      })
      .catch((error) => {
        console.error("Error adding service charge:", error);
        toast.error(error.response.data.response);
      });
  };

  const handleOpenUpdateModal = (withdrawCharge) => {
    setSelectedPropertyId(withdrawCharge.property_id);
    setModalData({
      property_id: withdrawCharge.property_id, // Added to modalData
      withdrawalfee: withdrawCharge.withdrawalfee,
    });
    setModalAction("Update"); // Track the action
    setIsModalOpen(true);
  };

  const handleModalInputChange = (e) => {
    const { name, value } = e.target;
    setModalData({ ...modalData, [name]: value });
  };

  return (
    <EmailGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto max-w-4xl rounded-2xl bg-white p-8 shadow-xl">
            <h1 className="mb-6 text-3xl font-bold tracking-tight text-gray-900">
              Withdrawal Rate Charge
            </h1>
            <button
              onClick={() => {
                setModalAction("Add");
                setModalData({ property_id: "", withdrawalfee: "" });
                setIsModalOpen(true);
              }}
              className="transform rounded-full bg-blue-600 px-6 py-3 font-semibold text-white shadow-md transition-all duration-200 hover:scale-105 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Add Withdrawal Fee
            </button>
            <div className="mt-8 overflow-x-auto rounded-lg shadow-md">
              <table className="min-w-full table-auto text-sm">
                <thead className="bg-gray-100">
                  <tr className="text-left text-xs font-semibold uppercase tracking-wider text-gray-600">
                    <th className="px-6 py-4">Property ID</th>
                    <th className="px-6 py-4">Withdrawal Fee</th>
                    <th className="px-6 py-4 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {withdrawalCharges.map((withdrawCharge) => (
                    <tr
                      key={withdrawCharge.property_id}
                      className="transition-colors duration-200 hover:bg-sky-50"
                    >
                      <td className="whitespace-nowrap px-6 py-4 font-medium text-gray-900">
                        {withdrawCharge.property_id}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-gray-700">
                        {withdrawCharge.withdrawalfee}
                      </td>
                      <td className="whitespace-nowrap px-6 py-4 text-center">
                        <div className="flex justify-center space-x-2">
                          <button
                            onClick={() => handleOpenUpdateModal(withdrawCharge)}
                            className="transform rounded-full bg-green-500 px-4 py-2 text-xs font-semibold text-white shadow-sm transition-all duration-200 hover:scale-105 hover:bg-green-600"
                          >
                            Update
                          </button>
                          <button
                            onClick={() => handleDeleteWithdrawal(withdrawCharge.property_id)}
                            className="transform rounded-full bg-red-500 px-4 py-2 text-xs font-semibold text-white shadow-sm transition-all duration-200 hover:scale-105 hover:bg-red-600"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {isModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 p-4 backdrop-blur-sm">
            <div className="w-full max-w-sm transform rounded-2xl bg-white p-8 shadow-2xl">
              {modalAction === "Update" ? (
                <>
                  <h2 className="mb-6 text-xl font-bold text-gray-800">
                    Update Withdrawal Fee
                  </h2>
                  <input
                    type="text"
                    name="withdrawalfee"
                    value={modalData.withdrawalfee}
                    onChange={handleModalInputChange}
                    placeholder="Withdrawal Fee"
                    className="mb-4 w-full rounded-lg border border-gray-300 px-4 py-2 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                  <div className="flex justify-end space-x-3">
                    <button
                      onClick={handleUpdateWithdrawalCharge}
                      disabled={isLoading}
                      className={`transform rounded-full px-6 py-2 font-semibold text-white transition-all duration-200 ${
                        isLoading
                          ? "cursor-not-allowed bg-gray-400"
                          : "bg-green-500 hover:scale-105 hover:bg-green-600"
                      }`}
                    >
                      {isLoading ? (
                        <Oval
                          height={20}
                          width={20}
                          color="white"
                          visible={true}
                          ariaLabel="loading-indicator"
                          secondaryColor="white"
                        />
                      ) : (
                        "Update"
                      )}
                    </button>
                    <button
                      onClick={() => setIsModalOpen(false)}
                      className="transform rounded-full bg-gray-400 px-6 py-2 font-semibold text-white shadow-sm transition-all duration-200 hover:scale-105 hover:bg-gray-500"
                    >
                      Cancel
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <h2 className="mb-6 text-xl font-bold text-gray-800">
                    Add Withdrawal Fee
                  </h2>
                  <input
                    type="text"
                    name="property_id"
                    value={modalData.property_id}
                    onChange={handleModalInputChange}
                    placeholder="Property ID"
                    className="mb-4 w-full rounded-lg border border-gray-300 px-4 py-2 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    name="withdrawalfee"
                    value={modalData.withdrawalfee}
                    onChange={handleModalInputChange}
                    placeholder="Withdrawal Fee"
                    className="mb-4 w-full rounded-lg border border-gray-300 px-4 py-2 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                  <div className="flex justify-end space-x-3">
                    <button
                      onClick={handleAddWithdrawalFee}
                      className="transform rounded-full bg-blue-600 px-6 py-2 font-semibold text-white shadow-sm transition-all duration-200 hover:scale-105 hover:bg-blue-700"
                    >
                      Add
                    </button>
                    <button
                      onClick={() => setIsModalOpen(false)}
                      className="transform rounded-full bg-gray-400 px-6 py-2 font-semibold text-white shadow-sm transition-all duration-200 hover:scale-105 hover:bg-gray-500"
                    >
                      Cancel
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </AuthGuard>
    </EmailGuard>
  );
};

export default WithdrawalRateChargePage;
